import type {
  ApplyPortfolioRequest,
  ApplyPortfolioResponse,
  InvestorProfileRequest,
  RecommendResult,
} from "@/types/portfolio-builder.types";
import { API_BASE_URL, fetchWithTimeout, handleResponse } from "./shared";

// ============================================================================
// Portfolio Builder API
// ============================================================================

export const portfolioBuilderApi = {
  async recommend(profile: InvestorProfileRequest): Promise<RecommendResult> {
    const response = await fetchWithTimeout(
      `${API_BASE_URL}/api/portfolio-builder/recommend`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(profile),
      }
    );
    return handleResponse<RecommendResult>(response);
  },

  async apply(data: ApplyPortfolioRequest): Promise<ApplyPortfolioResponse> {
    const response = await fetchWithTimeout(
      `${API_BASE_URL}/api/portfolio-builder/apply`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    );
    return handleResponse<ApplyPortfolioResponse>(response);
  },
};
